"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.withCookies = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

require("regenerator-runtime/runtime.js");

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _emptyFunction = _interopRequireDefault(require("fbjs/lib/emptyFunction"));

var _jsCookie = _interopRequireDefault(require("js-cookie"));

var _locales = require("@meepshop/locales");

var _useCookies2 = _interopRequireDefault(require("./hooks/useCookies"));

// FIXME: T10566, rewrite after next >= 12
// typescript import
// import
// definition
var CookiesContext = /*#__PURE__*/_react["default"].createContext({
  cookies: {},
  setCookie: _emptyFunction["default"]
});

var withCookies = function withCookies(getCookies) {
  return {
    appWithCookies: function appWithCookies(App) {
      var Component = function Component(_ref) {
        var initialCookies = _ref.initialCookies,
            props = (0, _objectWithoutProperties2["default"])(_ref, ["initialCookies"]);

        var _useCookies = (0, _useCookies2["default"])(initialCookies, getCookies),
            cookies = _useCookies.cookies,
            setCookie = _useCookies.setCookie;

        return /*#__PURE__*/_react["default"].createElement(CookiesContext.Provider, {
          value: {
            cookies: cookies,
            setCookie: setCookie
          }
        }, /*#__PURE__*/_react["default"].createElement(App, props));
      };

      Component.getInitialProps = App.getInitialProps;
      return Component;
    },
    getServerSideCookiesContextProps: function () {
      var _getServerSideCookiesContextProps = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(ctx) {
        var client, req, pathname, query, cache;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                client = ctx.client, req = ctx.req, pathname = ctx.pathname, query = ctx.query;
                cache = {};
                _context.prev = 2;
                _context.next = 5;
                return getCookies({
                  pathname: pathname,
                  query: query,
                  client: client,
                  i18n: req.i18n,
                  language: req.language,
                  cookie: {
                    get: function get(key) {
                      return req.cookies[key];
                    },
                    set: function set(key, value, options) {
                      cache[key] = [value, options];
                      req.cookies[key] = value;
                    }
                  }
                });

              case 5:
                _context.t0 = _context.sent;
                return _context.abrupt("return", {
                  initialCookies: _context.t0
                });

              case 9:
                _context.prev = 9;
                _context.t1 = _context["catch"](2);
                return _context.abrupt("return", {
                  initialCookies: {},
                  error: _context.t1
                });

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[2, 9]]);
      }));

      function getServerSideCookiesContextProps(_x) {
        return _getServerSideCookiesContextProps.apply(this, arguments);
      }

      return getServerSideCookiesContextProps;
    }(),
    getClientSideCookiesContextProps: function () {
      var _getClientSideCookiesContextProps = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(ctx) {
        var client, pathname, query;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                client = ctx.client, pathname = ctx.pathname, query = ctx.query;
                _context2.prev = 1;
                _context2.next = 4;
                return getCookies({
                  pathname: pathname,
                  query: query,
                  client: client,
                  i18n: _locales.i18n,
                  language: _locales.i18n.language,
                  cookie: _jsCookie["default"]
                });

              case 4:
                _context2.t0 = _context2.sent;
                return _context2.abrupt("return", {
                  initialCookies: _context2.t0
                });

              case 8:
                _context2.prev = 8;
                _context2.t1 = _context2["catch"](1);
                return _context2.abrupt("return", {
                  initialCookies: {},
                  error: _context2.t1
                });

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[1, 8]]);
      }));

      function getClientSideCookiesContextProps(_x2) {
        return _getClientSideCookiesContextProps.apply(this, arguments);
      }

      return getClientSideCookiesContextProps;
    }()
  };
};

exports.withCookies = withCookies;
var _default = CookiesContext;
exports["default"] = _default;